import {
    PRODUCT_LIST_REQUEST,
    PRODUCT_LIST_SUCCESS,
    PRODUCT_LIST_FAIL,
    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_DETAILS_FAIL,
    PRODUCT_DELETE_REQUEST,
    PRODUCT_DELETE_SUCCESS,
    PRODUCT_DELETE_FAIL,
    PRODUCT_CREATE_REVIEW_REQUEST,
    PRODUCT_CREATE_REVIEW_SUCCESS,
    PRODUCT_CREATE_REVIEW_FAIL,
    PRODUCT_CREATE_REVIEW_RESET,
    PRODUCT_CREATE_REQUEST,
    PRODUCT_CREATE_SUCCESS,
    PRODUCT_CREATE_FAIL,
    PRODUCT_CREATE_RESET,
    ARTISAN_PRODUCTS_REQUEST,
    ARTISAN_PRODUCTS_SUCCESS,
    ARTISAN_PRODUCTS_FAIL,
    ARTISAN_PRODUCTS_DETAIL_REQUEST,
    ARTISAN_PRODUCTS_DETAIL_SUCCESS,
    ARTISAN_PRODUCTS_DETAIL_FAIL,
    ARTISAN_PRODUCT_APPROVED_REQUEST,
    ARTISAN_PRODUCT_APPROVED_SUCCESS,
    ARTISAN_PRODUCT_APPROVED_FAIL,
    PRODUCT_APPROVED_REQUEST,
    PRODUCT_APPROVED_SUCCESS,
    PRODUCT_APPROVED_FAIL,
    APPROVED_PRODUCTS_REQUEST,
    APPROVED_PRODUCTS_SUCCESS,
    APPROVED_PRODUCTS_FAIL,
    PRODUCT_FILTER_REQUEST,
    PRODUCT_FILTER_SUCCESS,
    PRODUCT_FILTER_FAIL
} from '../constants/ProductConstants';


export const productListReducer = (state = { products: [] }, {type, payload}) => {
    
    switch (type) {
        case PRODUCT_LIST_REQUEST:
            return{
                loading: true,
                products: []
            }
        case PRODUCT_LIST_SUCCESS:
            return {
                loading: false,
                products: payload
            }
        case PRODUCT_LIST_FAIL: 
            return {
                loading: false,
                error: payload
            }
        default:
            return state;
    }
}


export const approvedProductListReducer = (state = { products: [] }, { type, payload }) => {

    switch (type) {
        case APPROVED_PRODUCTS_REQUEST:
            return {
                loading: true,
                products: []
            }
        case APPROVED_PRODUCTS_SUCCESS:
            return {
                loading: false,
                products: payload
            }
        case APPROVED_PRODUCTS_FAIL:
            return {
                loading: false,
                error: payload
            }
        default:
            return state;
    }
}



export const productDetailsReducer = (state = { product: {} }, {type, payload}) => {
    
    switch (type) {
        case PRODUCT_DETAILS_REQUEST:
            return{
                loading: true,
                product: {}
            }
        case PRODUCT_DETAILS_SUCCESS:
            return {
                loading: false,
                product: payload
            }
        case PRODUCT_DETAILS_FAIL: 
            return {
                loading: false,
                error: payload
            }
        default:
            return state;
    }
}



export const productDeleteReducer = (state = {}, { type, payload }) => {

    switch (type) {
        case PRODUCT_DELETE_REQUEST:
            return {
                loading: true
            }

        case PRODUCT_DELETE_SUCCESS:
            return {
                loading: false,
                success: true
            }

        case PRODUCT_DELETE_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}



export const productReviewCreateReducer = (state = {}, { type, payload }) => {
   
    switch (type) {

        case PRODUCT_CREATE_REVIEW_REQUEST:
            return { 
                loading: true 
            }

        case PRODUCT_CREATE_REVIEW_SUCCESS:
            return { 
                loading: false, 
                success: true 
            }

        case PRODUCT_CREATE_REVIEW_FAIL:
            return { 
                loading: false, 
                error: payload 
            }

        case PRODUCT_CREATE_REVIEW_RESET:
            return {}

        default:
            return state
    }
}




export const productCreateReducer = (state = {}, { type, payload }) => {

    switch (type) {
        case PRODUCT_CREATE_REQUEST:
            return {
                loading: true,
                ...state
            }

        case PRODUCT_CREATE_SUCCESS:
            return {
                loading: false,
                success: true,
                product: payload
            }

        case PRODUCT_CREATE_FAIL:
            return {
                loading: false,
                error: payload
            }
        case PRODUCT_CREATE_RESET:
            return {}

        default:
            return state;
    }
}


export const artisanProductsReducer = (state = { products: [] }, { type, payload }) => {

    switch (type) {
        case ARTISAN_PRODUCTS_REQUEST:
            return {
                loading: true,
                products: []
            }
        case ARTISAN_PRODUCTS_SUCCESS:
            return {
                loading: false,
                products: payload
            }
        case ARTISAN_PRODUCTS_FAIL:
            return {
                loading: false,
                error: payload
            }
        default:
            return state;
    }
}


export const aProductDetailsReducer = (state = { product: {} }, { type, payload }) => {

    switch (type) {
        case ARTISAN_PRODUCTS_DETAIL_REQUEST:
            return {
                loading: true,
                product: {}
            }
        case ARTISAN_PRODUCTS_DETAIL_SUCCESS:
            return {
                loading: false,
                product: payload
            }
        case ARTISAN_PRODUCTS_DETAIL_FAIL:
            return {
                loading: false,
                error: payload
            }
        default:
            return state;
    }
}



export const artisanProductApprovedReducer = (state = {}, { type, payload }) => {

    switch (type) {
        case ARTISAN_PRODUCT_APPROVED_REQUEST:
            return {
                loading: true
            }

        case ARTISAN_PRODUCT_APPROVED_SUCCESS:
            return {
                loading: false,
                success: true
            }

        case ARTISAN_PRODUCT_APPROVED_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}


export const productApprovedReducer = (state = {}, { type, payload }) => {

    switch (type) {
        case PRODUCT_APPROVED_REQUEST:
            return {
                loading: true
            }

        case PRODUCT_APPROVED_SUCCESS:
            return {
                loading: false,
                success: true
            }

        case PRODUCT_APPROVED_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}




export const productFilterListReducer = (state = { product_filter:{} }, { type, payload }) => {

    switch (type) {
        case PRODUCT_FILTER_REQUEST:
            return {
                loading: true,
            }
        case PRODUCT_FILTER_SUCCESS:
            return {
                loading: false,
                product_filter: payload
            }
        case PRODUCT_FILTER_FAIL:
            return {
                loading: false,
                error: payload
            }
        default:
            return state;
    }
}